export const GET_TREATMENT_GROUPS_QUERY_KEY = 'getTreatmentGroups';
export const GET_TREATMENT_GROUPS_FOR_PERSON_QUERY_KEY = 'getTreatmentGroupsForPerson';
export const GET_TREATMENT_GROUP_QUERY_KEY = 'getTreatmentGroup';
export const GET_TREATMENT_GROUP_FOR_PERSON_QUERY_KEY = 'getTreatmentGroupForPerson';
export const GET_TREATMENT_GROUP_MEMBERSHIPS_BY_PERSON_QUERY_KEY =
  'treatmentGroupMembershipsByPerson';

export const TREATMENT_GROUPS_PATH = '/treatment-groups';

export const TREATMENT_GROUP_VIEW_PARAM = 'groupId';
export const TREATMENT_GROUP_BOOKING_PARAM = 'treatmentGroupId';

export const ELIGIBILITY_APPLICATION_KEY = 'treatment_group_eligibility';
